import React, {Component}                               from "react";
import {Image, ImageBackground, Picker, Platform, View} from "react-native";
import {connect}                                        from "react-redux";
import {Text}                                           from "native-base";
import ModalHistory                                     from "../modals/ModalHistory";
import NBButton                                         from "../NBButton";
import RNMDropdown                                      from "../RNMDropdown";
import * as Actions                                     from "../../constants/Actions";
import * as Screens                                     from "../../constants/Screens";
import styles                                           from "../../styles/Styles";
import {loadMovies}                                     from "../../utils/MovieLoader";

const categories = require("../../../data/categories.json");

class ScreenCategory extends Component {
    selectCategory = (value) => {
        this.props.setCategory(value);
        this.props.setSubcategory(categories.subcategories[value][0]);
    }

    selectCategoryWeb= (itemValue, itemIndex) => {
        this.props.setCategory(itemValue);
        this.props.setSubcategory(categories.subcategories[itemValue][0]);
    }

    selectSubcategory = (value) => {
        if (this.props.category == null)
            return;

        var subcategories = categories.subcategories[this.props.category];
        var index = subcategories.indexOf(this.props.subcategory);
        index += value;

        if (index == subcategories.length)
            index = 0;
        else if (index < 0)
            index = subcategories.length - 1;

        this.props.setSubcategory(subcategories[index]);
    }

    startGame = () => {
        //If subcategory has been chosen, load relevant data file and proceed to game.
        if (this.props.subcategory != null) {
            var movies = loadMovies(this.props.category, this.props.subcategory);
            movies.sort((a, b) => (a.title > b.title) ? 1 : -1);
            
            this.props.loadMovies(movies);
            this.props.changeScreen(Screens.GAME);
        }
    }

    render() {
        var dropdown = null;
        if (Platform.OS === "web") {
            var listCategories = categories.categories.map((category, index) => {
                return <Picker.Item key={index} label={category} value={category} />
            });

            dropdown =  <Picker mode="dropdown" onValueChange={this.selectCategoryWeb} prompt="Select Category" selectedValue={this.props.category} style={styles.dropdownWeb}>
                            {listCategories}
                        </Picker>

            if (this.props.category == null)
                this.selectCategory(categories.categories[0]);
        }
        else {
            var listCategories = categories.categories.map((category, index) => ({value: category}));

            dropdown =  <RNMDropdown data={listCategories} label={"Select Category"} onChangeText={(value) => this.selectCategory(value)} 
                            value={this.props.category != null ? listCategories.find(cat => cat.value == this.props.category).value : ""} />
        }
        
        return (
            <View style={styles.background}>
                <ImageBackground source={require("../../../assets/screen_category.png")} style={styles.background} imageStyle={styles.backgroundImageScreen}>
                    <ModalHistory />

                    <View style={styles.viewCategoryDisplay}>
                        <Image source={require("../../../assets/now_playing.png")} />

                        {/* Category Selection */}
                        <View style={styles.viewCategoryDropdown}>
                            {dropdown}
                        </View>

                        {/* Subcategory Selection */}
                        <View style={styles.viewSubcategoryDisplay}>
                            <NBButton icon={"arrow-back"} iconFamily={"Ionicons"} iconType={"iconLeft"} onPress={() => {this.selectSubcategory(-1)}} text={"Back"} />

                            <View style={styles.viewSubcategoryPosterBackground}>
                                <ImageBackground source={require("../../../assets/category_poster.png")} style={styles.background} imageStyle={styles.backgroundImageStretch}>
                                    <View style={styles.viewSubcategoryPoster} >
                                        <Text style={styles.textWhite}>{this.props.subcategory}</Text>
                                    </View>
                                </ImageBackground>
                            </View>

                            <NBButton icon={"arrow-forward"} iconFamily={"Ionicons"} iconType={"iconRight"} onPress={() => {this.selectSubcategory(1)}} text={"Next"} />
                        </View>

                        <NBButton onPress={this.props.showHistory} text={"History"} />
                        <View style={styles.menuHorz}>
                            <NBButton onPress={() => this.props.changeScreen(Screens.TITLE)} text={"Exit Theater"} />
                            <NBButton onPress={this.startGame} text={"Take Your Seat"} />
                        </View>
                    </View>
                </ImageBackground>
            </View>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        category:       state.category,
        subcategory:    state.subcategory
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        changeScreen:   (screen)        => { dispatch({type: Actions.CHANGE_SCREEN,     screen:         screen}) },
        loadMovies:     (listMovies)    => { dispatch({type: Actions.LOAD_MOVIES,       listMovies:     listMovies}) },
        setCategory:    (category)      => { dispatch({type: Actions.SET_CATEGORY,      category:       category}) },
        setSubcategory: (subcategory)   => { dispatch({type: Actions.SET_SUBCATEGORY,   subcategory:    subcategory}) },
        showHistory:    ()              => { dispatch({type: Actions.SHOW_HISTORY}) }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ScreenCategory);